import React from 'react';
import { Col, Row } from 'components';
import { EmailContent } from './emailContent';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import styles from './styles.module.scss';
import { PurchaseRequestItems } from './items';
import { useParams } from 'react-router-dom';
import { FinalStatusBanner } from './FinalStatusBanner';
import { usePurchaseRequestByIdQuery } from 'api';

export const PurchaseRequestGeneral = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { data: { purchaseRequest } = {} } = usePurchaseRequestByIdQuery({ id });

  return (
    <HasAccess role={PERMISSIONS.purchaseRequests.purchaseRequest.read}>
      <Row className={styles.generalContainer}>
        <Col span={24} style={{ marginTop: 20 }}>
          {purchaseRequest?.isFinalStatus && <FinalStatusBanner status={purchaseRequest?.status} />}
        </Col>
        <Col span={24} style={{ marginTop: 20 }}>
          <EmailContent />
        </Col>
        <Col span={24} style={{ marginTop: 20 }}>
          <HasAccess role={PERMISSIONS.items.item.read}>
            <PurchaseRequestItems purchaseRequestId={id} />
          </HasAccess>
        </Col>
      </Row>
    </HasAccess>
  );
});
